"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENTS_SCOPE = 'some-scope'; //TODO: Change me!!!
//# sourceMappingURL=constants.js.map